/**
 * 提供 request 方法适配小程序调用方式的能力
 * @method adapter
 * @param {Function} func request 方法
 * @return {Function} 包装后的 request 方法
 */

import { isObject } from '@/utils/verify';

const METHOD_GET = 'GET';

const adapter = func => options => {
  let { data, method } = options;
  method = String(method || METHOD_GET).toUpperCase();

  if (isObject(data)) {
    if (method === METHOD_GET) {
      options.params = data;
      delete options.data;
    } else {
      options.data = JSON.stringify(data);
    }
  }

  return func(options);
};

export default adapter;
